import type { FormEvent, ReactElement } from 'react';
import { AppHeader } from '../components/layout/AppHeader';
import { isEntraLoginAvailable } from '../auth/entraAuth';

interface LoginPageProps {
  error: string;
  loginUsername: string;
  setLoginUsername: (v: string) => void;
  loginPassword: string;
  setLoginPassword: (v: string) => void;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  onEntraSignIn?: () => void | Promise<void>;
}

export function LoginPage({
  error,
  loginUsername,
  setLoginUsername,
  loginPassword,
  setLoginPassword,
  onSubmit,
  onEntraSignIn
}: LoginPageProps): ReactElement {
  const showEntra = Boolean(onEntraSignIn) && isEntraLoginAvailable();

  return (
    <div className="page">
      <AppHeader />
      <div className="app-content">
      <p className="subtitle">Sign in with a demo account or Microsoft Entra (when configured).</p>
      {error && <p className="error">{error}</p>}
      {showEntra && (
        <section className="card">
          <h2>Microsoft</h2>
          <button type="button" data-testid="login-entra" onClick={() => void onEntraSignIn?.()}>
            Sign in with Microsoft
          </button>
        </section>
      )}
      <section className="card">
        <h2>Demo login</h2>
        <form className="grid" data-testid="login-form" onSubmit={onSubmit}>
          <input
            data-testid="login-username"
            placeholder="Username"
            value={loginUsername}
            onChange={(e) => setLoginUsername(e.target.value)}
            required
          />
          <input
            data-testid="login-password"
            type="password"
            placeholder="Password"
            value={loginPassword}
            onChange={(e) => setLoginPassword(e.target.value)}
            required
          />
          <button type="submit" data-testid="login-submit">
            Sign In
          </button>
        </form>
      </section>
      <section className="card">
        <h2>Demo Test Logins</h2>
        <table className="inline-table">
          <thead>
            <tr>
              <th>Role</th>
              <th>Username</th>
              <th>Password</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Requestor</td>
              <td>requestor1</td>
              <td>Pass@123</td>
            </tr>
            <tr>
              <td>Regional Manager</td>
              <td>regional1</td>
              <td>Pass@123</td>
            </tr>
            <tr>
              <td>Procurement Manager</td>
              <td>procure1</td>
              <td>Pass@123</td>
            </tr>
            <tr>
              <td>Procurement Specialist</td>
              <td>specialist1</td>
              <td>Pass@123</td>
            </tr>
            <tr>
              <td>Administrator</td>
              <td>admin1</td>
              <td>Proc@123Admin</td>
            </tr>
            <tr>
              <td>Contract Admin</td>
              <td>contracts1</td>
              <td>Pass@123</td>
            </tr>
            <tr>
              <td>Division Order</td>
              <td>do1</td>
              <td>Pass@123</td>
            </tr>
            <tr>
              <td>Controller</td>
              <td>controller1</td>
              <td>Pass@123</td>
            </tr>
            <tr>
              <td>IT Support</td>
              <td>itsupport1</td>
              <td>Pass@123</td>
            </tr>
          </tbody>
        </table>
      </section>
      </div>
    </div>
  );
}
